export default __webpack_public_path__ + "static/media/phone.98d33f30.svg";